// export const URL='https://smsc.datagenit.com/apismpp/v1/'; // local
export const URL = 'https://smppintl.datagenit.com/apismpp/v1/'; // FOR international 
export const URLEC2 = 'https://smpp.datagenit.com/';
export const URL_SMSC = 'https://smppintl.datagenit.com/apismpp/'; // FOR international 